<!-- eslint-disable vue/multi-word-component-names -->

<script setup>

</script>

<template>
  <main class="w-full h-auto  my-1">
    <section class="container w-full mx-auto h-auto  flex flex-col justify-center items-center">
      <section class="w-full h-[350px] flex justify-center items-center ">
        <img src="./../assets/home.webp" class="w-full h-full object-cover" alt="">
      </section>

      <span class="w-full text-center my-5 font-bold text-xl">About Us</span>
      <p class="w-8/12 text-center">
        Established in 2010, Raya Medical group is a multi-service company, based in Iran with a commitment to providing the latest healthcare technology, services, and advanced solutions to our valued customers. Raya medical group is the industry leader and official distributor of the best healthcare products. Regarding our experience we can provide know-how technology for manufacturing various medical consumables.
      </p>

      <section class="w-full h-auto grid grid-rows-2 grid-cols-1  md:grid-cols-2 md:grid-rows-1 justify-center items-center my-2">
        
        <section class="w-full h-full col-span-1 flex flex-col justify-start items-center">
          <span class="w-full text-center my-5 font-bold text-xl">Our Mission</span>
          <p class="w-10/12 text-center">
            At Raya Medical group, we are dedicated to offering our valued customers medical supplies that are of high quality. We believe in offering the best customer services, which means putting our customers' needs and satisfaction above all else. We strive to meet and exceed our customers' expectations by providing exceptional service and experienced staff. We are committed to being the leading medical equipment distributor as a whole. We aim to accomplish this by providing superior products and unparalleled customer service through knowledgeable, experienced staff. Our goal is to be your first choice for any of your medical equipment needs.
          </p>
        </section>

        <section class="w-full h-full col-span-1 flex flex-col justify-start items-center">
          <span class="w-full text-center my-5 font-bold text-xl">Our Team</span>
          <p class="w-10/12 text-center">
            As a multi-service company, we have an experienced and knowledgeable team to provide you with unsurpassed service. Our staff members are committed to ensuring that our valued customers' needs are met.
          </p>
        </section>

        
      </section>



    </section>
  </main>
</template>

<style scoped></style>
